import type { ButtonProps as AntdButtonProps } from 'antd'
import { Button as AntdButton } from 'antd'
import type { Ref } from 'react'

export interface ButtonProps extends AntdButtonProps {
  className?: string
  loading?:
    | boolean
    | {
        delay?: number
      }
  ref?: Ref<null>
}

export default function Button({ type = 'primary', className, shape, ...props }: ButtonProps & AntdButtonProps) {
  return (
    <AntdButton
      className={`text-sm! uppercase! font-bold! ${shape ? '' : 'rounded!'} flex justify-center items-center ${className || ''}`}
      type={type}
      shape={shape}
      {...props}
    />
  )
}
